import { Capacitor } from "@capacitor/core";
import { Box } from "@mui/material";
import { type FC, useEffect } from "react";
import { NotificationsList } from "../../components/notificationItem/NotificationsList";
import { pushNotificationService } from "../../services/pushNotification.service";
import { NEUTRAL } from "../../theme/tokens";
import { useNotificationsPageViewedTracking } from "./useNotificationsPageViewedTracking";

/** `/notifications`: the signed-in user's notifications inbox, full page. The admin bell's Notifications tab shows the same list. */
export const NotificationsPage: FC = () => {
	useNotificationsPageViewedTracking();

	// Opening the inbox clears the app icon's badge on mobile.
	useEffect(() => {
		if (Capacitor.isNativePlatform()) {
			pushNotificationService.clearBadge();
		}
	}, []);

	return (
		<Box
			data-testid="notifications-root"
			sx={{
				height: "100%",
				width: "100%",
				bgcolor: NEUTRAL[50],
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				overflow: "auto",
				scrollBehavior: "smooth",
				overscrollBehavior: "contain",
				maxWidth: "lg",
				mx: "auto",
				p: 2,
			}}
		>
			<NotificationsList surface="page" dataTestId="notifications-list" />
		</Box>
	);
};
